import { useEffect } from 'react';

/** Browser tab base — matches `index.html` pre-hydration `<title>`. */
export const APP_TITLE = 'WSReporting';

/**
 * Sets `WSReporting — {title}` while mounted; restores the base title on unmount.
 * When `title` is empty, sets plain `APP_TITLE`.
 */
export function useDocumentTitle(title: string): void {
  useEffect(() => {
    document.title = title.trim().length === 0 ? APP_TITLE : `${APP_TITLE} — ${title}`;
    return () => {
      document.title = APP_TITLE;
    };
  }, [title]);
}
